const $ = require("app/util/element");

function classList() {
	return Array.from(arguments).reduce((acc, className) => {
		return typeof className === "string" && (className.length > 0) ?
			acc.concat([className]) : acc;

	}, []).join(" ");
}

function getElementOffset(element) {
	const elementRect = element.getBoundingClientRect();

	return {
		left: elementRect.left + window.pageXOffset,
		top: elementRect.top + window.pageYOffset
	};
}

module.exports = {
	classList,
	getElementOffset
};

